import { baseAPI } from "../../baseApi"

export const repairPlanApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        getRepairPlans: builder.query<any, { $orderby?: string, $filter?: string, $top?: number }>({
            query: ({ $orderby, $filter, $top }) => ({
                url: `Diagnostics/RepairPlans`,
                params: { $orderby, $filter, $top }
            })
        }),
        getRepairSegments: builder.query<any, { $orderby?: string, $filter?: string, $top?: number }>({
            query: ({ $orderby, $filter, $top }) => ({
                url: `Diagnostics/RepairSegments`,
                params: { $orderby, $filter, $top }
            })
        }),
        getRepairSegmentsLength: builder.query<any, { RepairPlanId?: number, StandartWorkTypes?: number[], Raions?: number[] }>({
            query: ({ RepairPlanId, StandartWorkTypes, Raions }) => ({
                url: `Diagnostics/repairSegmentAmount`,
                method: "POST",
                body: { RepairPlanId, StandartWorkTypes, Raions }
            })
        }),
    })
})

export const {
    useGetRepairPlansQuery,
    useGetRepairSegmentsQuery,
    useGetRepairSegmentsLengthQuery
} = repairPlanApiSlice